<template>
  <div id="user-detailed">
    <el-dialog title="充值奖励金明细" :visible.sync="show" width="1015px" :show-close="false" :close-on-click-modal="false">
      <div>
        <el-row :gutter="24" style="margin-bottom:20px;">
          <el-col style="display:flex;" :span="8">
            <div class="searchLable">下单时间：</div>
            <el-date-picker
              v-model="orderTime"
              class="searchContent"
              unlink-panels
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-col>
          <el-col style="display:flex;" :span="6">
            <div class="searchLable">单据类型：</div>
            <el-select v-model="formInline.fBillType" class="searchContent" placeholder="请选择">
              <el-option label="全部" :value="0" />
              <el-option label="奖励金" :value="1" />
              <el-option label="商城订单" :value="2" />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button style="height:36px;" type="primary" @click="onSubmit(true)">查询</el-button>
          </el-col>
          <el-col :span="8">
            <div class="amountTotal">
              充值奖励金：<span style="color: rgb(237, 159, 61);font-size:20px;">￥{{ fBonusAmountToal }}</span>
            </div>
          </el-col>
        </el-row>
        <!-- <div style="height:38px;color:#000;font-weight:800;position:relative;">
          <span style="position: absolute;right:5px;" />
        </div> -->
        <el-table height="300px" :data="gridData">
          <el-table-column
            label="序号"
            type="index"
          />
          <el-table-column header-align="center" property="fNo" label="业务单号" />
          <el-table-column header-align="center" property="fOrderAmount" label="订单金额" />
          <el-table-column header-align="center" property="fBonusAmount" label="奖励金额" />
          <el-table-column header-align="center" property="fBonusDateTime" label="单据时间" />
          <el-table-column header-align="center" property="fBonusBalance" label="抵扣奖励金" />
        </el-table>
        <el-pagination
          style="text-align:center;padding: 10px 0;"
          :current-page.sync="pagination.pageNo"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper"
          :total="pagination.total"
          @current-change="onSubmit"
        />
        <el-button
          type="danger"
          plain
          style="padding: 6px 36px; margin: auto; display: block;"
          @click="show=false"
        >关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import quest from '../../api/user'
export default {

  data() {
    return {
      fBonusAmountToal: '0.00',
      show: false,
      gridData: [],
      pagination: {
        pageSize: 30,
        pageNo: 1,
        total: 0
      },
      orderTime: [],
      formInline: {
        fbeginTime: '',
        fendTime: '',
        fBillType: 0
      }
    }
  },
  created() {
    this.$on('dilong-detailed', (val) => {
      this.show = val
    })
  },
  mounted() {

  },
  methods: {
    onSubmit(reset) {
      if (reset) {
        this.pagination = {
          pageSize: 30,
          pageNo: 1,
          total: 0
        }
      }
      if (this.orderTime && this.orderTime.length) {
        this.formInline.fbeginTime = this.orderTime[0]
        this.formInline.fendTime = this.orderTime[1]
      } else {
        this.formInline.fbeginTime = this.formInline.fendTime = ''
      }
      quest
        .DemandBonus({
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
          jsonStr: encodeURI(JSON.stringify(this.formInline))
        })
        .then(res => {
          this.$set(this, 'gridData', res.data.list.records)
          this.fBonusAmountToal = res.data.fBonusAmountToal
        })
    }
  }
}
</script>

<style lang="scss" >
#user-detailed {
    .searchLable {
        width: 80px;
        font-size: 14px;
        line-height: 36px;
        color: rgb(146, 150, 168)
    }
    .searchContent {
        width: calc(100% - 80px);
        height: 36px;
        .el-input__inner {
            height: 36px;
        }
        .el-range__icon {
            line-height: 28px;
        }
    }
    .amountTotal {
        height: 36px;
        line-height: 36px;
        float: right;
        // font-size: 14px;
    }
  .el-dialog {
    // width: 825px;
    height: 538px;
    border-radius: 10px;
    .el-dialog__header {
      padding-left: 26px;
      text-align: left;
      border-radius: 10px 10px 0 0;
    }
    .el-dialog__body {
        padding: 30px 26px;
    }
    .el-table td,
    .el-table th.is-leaf {
      padding: 4px 0;
      height: 30px;
    }
    .el-table th.is-leaf {
      background-color: #fff;
      color: rgb(96, 98, 102);
    }
  }
  .el-form {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner,
    .el-input {
    //   width: 126px;
    }
  }
}
</style>
